import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, of, switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';
import { TokenStore } from './token.store';

const ADMIN = `${environment.apiUrl}admin/`;
const PUBLIC_AUTH = [`${ADMIN}auth/login`, `${ADMIN}auth/refresh`];

const withToken = (req: HttpRequest<unknown>, token: string | null) =>
  token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(ADMIN) || PUBLIC_AUTH.some((u) => req.url.startsWith(u))) {
    return next(req);
  }
  const tokens = inject(TokenStore);
  const auth = inject(AuthService);

  return next(withToken(req, tokens.access)).pipe(
    catchError((err: unknown) => {
      if (!(err instanceof HttpErrorResponse) || err.status !== 401) {
        return throwError(() => err);
      }
      // Try to refresh once, then retry; otherwise send the user to login.
      return auth.refresh().pipe(
        catchError(() => of(false)),
        switchMap((ok) => {
          if (!ok) {
            auth.logout();
            return throwError(() => err);
          }
          return next(withToken(req, tokens.access)).pipe(
            catchError((retryErr: unknown) => {
              if (retryErr instanceof HttpErrorResponse && retryErr.status === 401) auth.logout();
              return throwError(() => retryErr);
            }),
          );
        }),
      );
    }),
  );
};
